// extracted by mini-css-extract-plugin
module.exports = {"CustomerSupport":"CustomerSupport_CustomerSupport__ypISE"};